const state = {
    startPlace: '上海',
    endPlace: '北京',
    departureDate: new Date().toISOString().split('T')[0]
};

const mutations = {
    setStartPlace(state, newPlace) {
        state.startPlace = newPlace;
    },
    setEndPlace(state, newPlace) {
        state.endPlace = newPlace;
    },
    setDepartureDate(state, newDate) {
        state.departureDate = newDate;
    }
};

const actions = {
    updateStartPlace({ commit }, newPlace) {
        commit('setStartPlace', newPlace);
    },
    updateEndPlace({ commit }, newPlace) {
        commit('setEndPlace', newPlace);
    },
    updateDepartureDate({ commit }, newDate) {
        commit('setDepartureDate', newDate);
    }
};

const getters = {
    getStartPlace(state) {
        return state.startPlace;
    },
    getEndPlace(state) {
        return state.endPlace;
    },
    getDepartureDate(state) {
        return state.departureDate;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
